module.exports = __webpack_public_path__ + "Server-Default.AzureServiceFabricCluster.d39bfd469b7d5ea3bf8fb996e098fc82.hashedasset.svg";